import axios from 'axios';
import React, {  useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { fetchUsers } from '../../../../redux/reducer/postFetcReducer/action/action';
import { useDispatch } from "react-redux";
import { getMyCompany } from '../../../../redux/reducer/getCompany/action/action';

import Spinner from 'react-bootstrap/Spinner';
import { getCompanyForChangeAPI } from '../../../../redux/reducer/myCompanyAPI/action/action';
import { checkedSessionAction } from '../../../../redux/reducer/getCheckedCompanySession/action/action';
import { useToast } from '@chakra-ui/react'
import DeleteCompanyModal from './deleteCompanyModal';

export default function DeleteCompany({ items }) {

  const dispatch = useDispatch()
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [load, setLoad] = useState(false)
  const toast = useToast()

  



  const handleDeleteCompany = () => {



    dispatch(checkedSessionAction("/getCheckedCompanySession"));
    dispatch(getMyCompany("/mycopany/getallcompany"))
    setLoad(true)
    dispatch(fetchUsers())
    axios.delete('/mycopany/delete', {
      data: {
        companyId: items.companyId,

      }
    })
      .then(function (response) {
        console.log(response, "resp");
        setLoad(false)
        dispatch(fetchUsers())
        setShow(false)
        dispatch(getCompanyForChangeAPI("/changeapi/api"));
        dispatch(checkedSessionAction("/getCheckedCompanySession"));
        dispatch(getMyCompany("/mycopany/getallcompany"))
      })
      .catch(function (error) {
        console.log(error);
        setLoad(false)
        setShow(false)
        toast({
          position: "top",
          title: 'Ошибка',
          description: error.response.data.message,
          status: 'error',
          duration: 9000,
          isClosable: true,
        })
      }).finally(final => {
        dispatch(fetchUsers())
      }).finally(finall => {
        setShow(false)
        dispatch(fetchUsers())
        dispatch(getCompanyForChangeAPI("/changeapi/api"));
        dispatch(checkedSessionAction("/getCheckedCompanySession"));
        dispatch(getMyCompany("/mycopany/getallcompany"))
      })

  }




  return (
    <>

      {/* <span className="material-symbols-outlined" style={{ color: "#DB5F95", cursor: "pointer" }} onClick={handleShow}>delete</span> */}
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" onClick={handleShow}>
  <path fillRule="evenodd" clipRule="evenodd" d="M8.5 6V3.5H15V6H8.5ZM7.75 7.5H15.75H20.75C21.1642 7.5 21.5 7.16421 21.5 6.75C21.5 6.33579 21.1642 6 20.75 6H16.5V3.35C16.5 2.60444 15.8956 2 15.15 2H8.35C7.60442 2 7 2.60442 7 3.35V6H2.75C2.33579 6 2 6.33579 2 6.75C2 7.16421 2.33579 7.5 2.75 7.5H7.75ZM5.5 10.75C5.5 10.3358 5.16421 10 4.75 10C4.33579 10 4 10.3358 4 10.75V20.15C4 20.8956 4.60444 21.5 5.35 21.5H18.15C18.8956 21.5 19.5 20.8956 19.5 20.15V10.75C19.5 10.3358 19.1642 10 18.75 10C18.3358 10 18 10.3358 18 10.75V20H5.5V10.75ZM10.5 10.75C10.5 10.3358 10.1642 10 9.75 10C9.33579 10 9 10.3358 9 10.75V16.75C9 17.1642 9.33579 17.5 9.75 17.5C10.1642 17.5 10.5 17.1642 10.5 16.75V10.75ZM13.75 10C14.1642 10 14.5 10.3358 14.5 10.75V16.75C14.5 17.1642 14.1642 17.5 13.75 17.5C13.3358 17.5 13 17.1642 13 16.75V10.75C13 10.3358 13.3358 10 13.75 10Z" fill="#DD5E98"/>
</svg>
      {/* <Modal  onHide={handleClose} size={"lg"}>
        <Modal.Header closeButton>
          <Modal.Title style={{ textAlign: "center" }}>Вы собираетесь удалить компанию?</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ textAlign: "center", fontSize: "48px", color: "red" }}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M8.5 6V3.5H15V6H8.5ZM7.75 7.5H15.75H20.75C21.1642 7.5 21.5 7.16421 21.5 6.75C21.5 6.33579 21.1642 6 20.75 6H16.5V3.35C16.5 2.60444 15.8956 2 15.15 2H8.35C7.60442 2 7 2.60442 7 3.35V6H2.75C2.33579 6 2 6.33579 2 6.75C2 7.16421 2.33579 7.5 2.75 7.5H7.75ZM5.5 10.75C5.5 10.3358 5.16421 10 4.75 10C4.33579 10 4 10.3358 4 10.75V20.15C4 20.8956 4.60444 21.5 5.35 21.5H18.15C18.8956 21.5 19.5 20.8956 19.5 20.15V10.75C19.5 10.3358 19.1642 10 18.75 10C18.3358 10 18 10.3358 18 10.75V20H5.5V10.75ZM10.5 10.75C10.5 10.3358 10.1642 10 9.75 10C9.33579 10 9 10.3358 9 10.75V16.75C9 17.1642 9.33579 17.5 9.75 17.5C10.1642 17.5 10.5 17.1642 10.5 16.75V10.75ZM13.75 10C14.1642 10 14.5 10.3358 14.5 10.75V16.75C14.5 17.1642 14.1642 17.5 13.75 17.5C13.3358 17.5 13 17.1642 13 16.75V10.75C13 10.3358 13.3358 10 13.75 10Z" fill="#DD5E98" />
          </svg>


        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Отмена
          </Button>
          {load ?
            <Button variant="primary" disabled>
              <Spinner
                as="span"
                animation="grow"
                size="sm"
                role="status"
                aria-hidden="true"
              />
              Loading...
            </Button>
            :
            <Button variant="primary" onClick={handleDeleteCompany} style={{ backgroundColor: "#DB5F95", border: "none" }}>
              Подтвердить
            </Button>
          }
        </Modal.Footer>
      </Modal> */}
      <DeleteCompanyModal show={show} setShow={setShow} handleDeleteCompany={handleDeleteCompany}/>
    </>
  )
}